import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject critical resource hints at module level (earliest possible without index.html access)
// Preconnect to CDN — only if not already present
if (!document.querySelector('link[rel="preconnect"][href*="cdn.magicpatterns.com"]')) {
  const preconnectCDN = document.createElement('link');
  preconnectCDN.rel = 'preconnect';
  preconnectCDN.href = 'https://cdn.magicpatterns.com';
  preconnectCDN.crossOrigin = 'anonymous';
  document.head.appendChild(preconnectCDN);
}
// Preload LCP image with high fetchpriority
const preloadLCP = document.createElement('link');
preloadLCP.rel = 'preload';
preloadLCP.as = 'image';
preloadLCP.href = 'https://cdn.magicpatterns.com/uploads/et1BNBjeqyFuoBWJVmg5Bk/portada.webp';
preloadLCP.type = 'image/webp';
(preloadLCP as any).fetchPriority = 'high';
document.head.appendChild(preloadLCP);
// Load Google Fonts asynchronously — only if not already loaded by platform
if (!document.querySelector('link[href*="fonts.googleapis.com/css2"]')) {
  const fontsLink = document.createElement('link');
  fontsLink.rel = 'stylesheet';
  fontsLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@400;700&display=swap';
  fontsLink.media = 'print';
  fontsLink.onload = () => {
    fontsLink.media = 'all';
  };
  document.head.appendChild(fontsLink);
}
render(<App data-id="element-366" />, document.getElementById('root'));